import React from "react";
import EmptyChat from "./assets/EmptyChat.png";

const GiftedChatEmptyView = () => (
  <div>
    <img src={EmptyChat} alt="Empty Chat" />
    <p>No Messages yet. Send the first!</p>
    <style jsx>{`
      div {
        display: flex;
        transform: scaleY(-1);
        height: 100%;
        width: 100%;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding: 0 25px 0 15px;
      }
      img {
        width: 50%;
        height: auto;
      }
      p {
        color: #bab9b9;
        font-weight: bold;
        font-size: 0.9rem;
      }
    `}</style>
  </div>
);

export default GiftedChatEmptyView;
